import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _create_class } from "@swc/helpers/_/_create_class";
import { _ as _get } from "@swc/helpers/_/_get";
import { _ as _get_prototype_of } from "@swc/helpers/_/_get_prototype_of";
import { _ as _inherits } from "@swc/helpers/_/_inherits";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _create_super } from "@swc/helpers/_/_create_super";
import { State } from "../../State";
import GestureHandlerOrchestrator from "../tools/GestureHandlerOrchestrator";
import GestureHandler from "./GestureHandler";
var HoverGestureHandler = /*#__PURE__*/ function(GestureHandler) {
    "use strict";
    _inherits(HoverGestureHandler, GestureHandler);
    var _super = _create_super(HoverGestureHandler);
    function HoverGestureHandler() {
        _class_call_check(this, HoverGestureHandler);
        return _super.apply(this, arguments);
    }
    _create_class(HoverGestureHandler, [
        {
            key: "init",
            value: function init(ref, propsRef) {
                _get(_get_prototype_of(HoverGestureHandler.prototype), "init", this).call(this, ref, propsRef);
            }
        },
        {
            key: "updateGestureConfig",
            value: function updateGestureConfig(_param) {
                var _param_enabled = _param.enabled, enabled = _param_enabled === void 0 ? true : _param_enabled, props = _object_without_properties(_param, [
                    "enabled"
                ]);
                _get(_get_prototype_of(HoverGestureHandler.prototype), "updateGestureConfig", this).call(this, _object_spread({
                    enabled: enabled
                }, props));
            }
        },
        {
            key: "onPointerMoveOver",
            value: function onPointerMoveOver(event) {
                GestureHandlerOrchestrator.getInstance().recordHandlerIfNotPresent(this);
                this.tracker.addToTracker(event);
                _get(_get_prototype_of(HoverGestureHandler.prototype), "onPointerMoveOver", this).call(this, event);
                if (this.getState() === State.UNDETERMINED) {
                    this.begin();
                    this.activate();
                }
            }
        },
        {
            key: "onPointerMoveOut",
            value: function onPointerMoveOut(event) {
                this.tracker.addToTracker(event);
                _get(_get_prototype_of(HoverGestureHandler.prototype), "onPointerMoveOut", this).call(this, event);
                this.end();
            }
        },
        {
            key: "onPointerMove",
            value: function onPointerMove(event) {
                this.tracker.track(event);
                _get(_get_prototype_of(HoverGestureHandler.prototype), "onPointerMove", this).call(this, event);
            }
        },
        {
            key: "onPointerCancel",
            value: function onPointerCancel(event) {
                _get(_get_prototype_of(HoverGestureHandler.prototype), "onPointerCancel", this).call(this, event);
                this.reset();
            }
        }
    ]);
    return HoverGestureHandler;
}(GestureHandler);
export { HoverGestureHandler as default };
